import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  InteractiveBarChart,
  InteractiveLineChart,
  PieChartWithLegend,
  PlayerRadarChart,
} from '../charts';
import typography from '../../design-system/typography';

const CHART_HEIGHT = 300;

const ChartRenderer = ({ data }) => {
  if (!data) return null;

  const { chartType, title, ...chartData } = data;

  const renderChart = () => {
    switch (chartType) {
      case 'bar':
        return (
          <InteractiveBarChart
            data={chartData.data || []}
            dataKeys={chartData.dataKeys || []}
            title={undefined}
            height={CHART_HEIGHT}
            showLegend={chartData.showLegend !== false}
          />
        );

      case 'line':
        return (
          <InteractiveLineChart
            data={chartData.data || []}
            dataKeys={chartData.dataKeys || []}
            title={undefined}
            height={CHART_HEIGHT}
            showLegend={chartData.showLegend !== false}
          />
        );

      case 'pie':
        return (
          <PieChartWithLegend
            data={chartData.data || []}
            title={undefined}
            height={CHART_HEIGHT}
          />
        );

      case 'radar':
        return (
          <PlayerRadarChart
            players={chartData.players || []}
            metrics={chartData.metrics || undefined}
            title={undefined}
            height={CHART_HEIGHT}
          />
        );

      default:
        return (
          <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            Tipo de gráfico no soportado: {chartType}
          </Typography>
        );
    }
  };

  return (
    <Box sx={{ my: 1 }}>
      {title && (
        <Typography
          variant="subtitle2"
          sx={{
            mb: 1,
            fontWeight: typography.fontWeight.semibold,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
      )}
      <Box sx={{ width: '100%', maxHeight: CHART_HEIGHT + 60, overflow: 'hidden' }}>
        {renderChart()}
      </Box>
    </Box>
  );
};

export default ChartRenderer;
